import React from "react";
import { getNotificationIcon } from "../../Helpers/notificationIcons";

export default function BrandNotificationItem(props) {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  };

  const setRead = () => {
    let newNotifModul = [...props.NotifModul];
    const newVisitedItemIndex = newNotifModul.findIndex((item) => {
      return item.id === props.id;
    });
    if (newVisitedItemIndex !== -1) {
      props.updateNotificationStatus(
        newNotifModul[newVisitedItemIndex].id,
        "read"
      );
      newNotifModul[newVisitedItemIndex].read = true;
      props.setNotifModul(newNotifModul);
      props.setModalData();
      if (props.modal !== "notifDetail") {
        props.setModalNotification("notifDetailDash");
      } else {
        props.setModalNotification("notifDetail");
      }
      props.setModalNotificationData(newNotifModul[newVisitedItemIndex]);
    }
  };

  return (
    <div
      onClick={setRead}
      className="group"
      style={{
        width: "100%",
        display: "flex",
        alignItems: "flex-start",
        gap: "clamp(8px, 2vw, 16px)",
        padding: "clamp(12px, 3vw, 16px) clamp(12px, 4vw, 20px)",
        backgroundColor: "#fff",
        borderBottom: "1px solid #F1F5F9",
        cursor: "pointer",
        transition: "all 0.2s ease",
        position: "relative",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#F8FAFC";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "#fff";
      }}
    >
      {/* Avatar Section */}
      <div style={{ position: "relative", flexShrink: 0 }}>
        <div
          style={{
            width: "clamp(32px, 8vw, 42px)",
            height: "clamp(32px, 8vw, 42px)",
            borderRadius: "50%",
            overflow: "hidden",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
            backgroundColor: "#F3F4F6",
            border: "1px solid #F1F5F9",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {props.image?.startsWith("http") ? (
            <img
              src={props.image}
              alt=""
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          ) : (
            getNotificationIcon(props.sytemNotiType, window.innerWidth < 640 ? 16 : 20)
          )}
        </div>
      </div>

      {/* Content Section */}
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          gap: "2px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <h6
            style={{
              fontSize: "clamp(12px, 3vw, 14px)",
              fontWeight: "600",
              color: "#111827",
              margin: 0,
              lineHeight: "1.2",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              flex: 1,
              minWidth: 0,
            }}
          >
            {props.title}
          </h6>

          <span
            style={{
              fontSize: "clamp(10px, 2.5vw, 12px)",
              color: "#9CA3AF",
              whiteSpace: "nowrap",
              fontWeight: "400",
              flexShrink: 0,
            }}
          >
            {formatDate(props.date)}
          </span>
        </div>

        <p
          style={{
            fontSize: "clamp(11px, 2.8vw, 13px)",
            color: "#6B7280",
            margin: 0,
            lineHeight: "1.3",
            overflow: "hidden",
            textOverflow: "ellipsis",
            wordBreak: "break-word",
          }}
        >
          {props.text}
        </p>
      </div>
    </div>
  );
}
